<div class = "centered" *ngIf="loading">
	<div class = "blob-1"></div>
	<div class = "blob-1-b"></div>
	<div class = "blob-2"></div>
	<div class = "blob-2-b"></div>
	<div class = "blob-mid"></div>
</div>
